import { Box, Divider, Tooltip, Typography } from '@mui/material';
import React from 'react';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import AddTaskIcon from '@mui/icons-material/AddTask';
import { cleanText } from '@components/QuestionGenerationService/utils/helpers';
import ShowIf from '@components/Atoms/ShowIf';
import { AlgoliaPassage } from './types';
import { MODES } from './Passages';

const PassageListItem: React.FC<{
  passage: AlgoliaPassage;
  switchMode: (mode: string, passage?: AlgoliaPassage | string | null) => void;
  inDialog?: boolean;
}> = ({ passage, switchMode, inDialog }) => {
  const passageText = cleanText(passage.content) || 'Passage';

  const getPassageHeading = () => {
    const { title } = passage;
    if (title) {
      return title;
    }
    return `${passageText.substring(0, 100)}...`;
  };

  return (
    <>
      <Box
        key={passage.objectID}
        sx={{
          display: 'flex',
          py: '1rem',
          alignItems: 'flex-end',
          gap: '1rem',
          pr: '1rem',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              pb: '0.5rem',
            }}
          >
            <Typography
              variant="h3"
              sx={{ color: 'black', fontWeight: 'bold' }}
              data-testid="passage-list-item-title"
            >
              {getPassageHeading()}
            </Typography>
            <Box
              sx={{ display: 'flex', gap: '1rem' }}
              data-testid="passage-list-item-actions"
            >
              <Tooltip title="View Passage" placement="top">
                <RemoveRedEyeIcon
                  sx={{ color: 'primary.main', cursor: 'pointer' }}
                  onClick={() => {
                    switchMode(MODES.PASSAGE_MODE, passage.objectID);
                  }}
                />
              </Tooltip>

              <ShowIf If={!inDialog}>
                <Tooltip title="View questions with this passage" placement="top">
                  <ViewStreamIcon
                    sx={{ color: 'primary.main', cursor: 'pointer' }}
                    onClick={() => switchMode(MODES.PASSAGE_ITEMS_MODE, passage.objectID)}
                  />
                </Tooltip>
              </ShowIf>

              <Tooltip title="Select this passage" placement="top">
                <AddTaskIcon
                  sx={{ color: 'primary.main', cursor: 'pointer' }}
                  onClick={() => switchMode(MODES.PASSAGE_SELECT_MODE, passage.objectID)}
                />
              </Tooltip>
            </Box>
          </Box>
          <Typography
            variant="body1"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '1.5rem',
              maxHeight: '4.5rem',
            }}
            data-testid="passage-list-item-content"
          >
            {passageText}
          </Typography>
        </Box>
      </Box>
      <Divider orientation="horizontal" variant="fullWidth" />
    </>
  );
};

export default PassageListItem;
